import { cn } from '@poseidon/components/cn';

import { ButtonWTip } from '@poseidon/components/Button';
import { Arrows } from '@poseidon/components/StrokeIcons';

import { Kbd } from '@/components/Kbd';
import { isMacLike } from '@/hooks/useKey';
import { LogoIcon, LogoText } from '~/components/ToneIcons';
import styles from './LeftNav.module.scss';

type LogoRowProps = {
  navMinimized: boolean;
  setNavMinimized: (newValue: boolean | null) => void;
};
export const LogoRow = ({ navMinimized, setNavMinimized }: LogoRowProps) => {
  return (
    <div className={cn(styles.logo, 'flex')}>
      <span className="flex size-8 shrink-0 items-center justify-center">
        <LogoIcon />
      </span>
      <span className={cn(styles.logoText, 'whitespace-pre')}>
        <LogoText className="h-full" />
      </span>

      <ButtonWTip
        className={cn('absolute right-0', { 'rotate-180': navMinimized })}
        text
        icon={<Arrows.ChevronLeftDouble />}
        tooltip={
          navMinimized ? (
            <span>
              Expand <Kbd>{isMacLike() ? '⌘' : 'ctrl'}+B</Kbd>
            </span>
          ) : (
            <span>
              Minimize <Kbd>{isMacLike() ? '⌘' : 'ctrl'}+B</Kbd>
            </span>
          )
        }
        tooltipPlacement="top"
        onClick={() => setNavMinimized(!navMinimized)}
      />
    </div>
  );
};
